<template>

</template>
<script>

export default {
	data() {
		return {
            collapsed: false
		};
	}
};
</script>
